import { collection, getDocs, query, where } from "firebase/firestore";

import { db } from "../utilities/firebase";

export async function fetchStaff(governmentBody, id) {
  //creating and executing firestore query
  //only return docs where "reports to elected" array contains
  //provided id of legislator
  const staffers = await getDocs(
    query(
      collection(db, governmentBody),
      where("Reports to Elected", "array-contains", id),
    ),
  ).then((snapshot) =>
    //converting firestore document objects to js objects
    snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data(),
    })),
  );

  return {
    type: "FETCH_STAFF",
    payload: staffers,
  };
}

export function clearStaff() {
  return {
    type: "CLEAR_STAFF",
  };
}
